import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
} from '@tanstack/react-table';
import { useMemo } from 'react';

import { coachSessionsTableColumnsData } from 'features/sessions/config/coachTableColumnsData';
import {
  SessionListItemType,
  SessionTableItemType,
} from 'features/sessions/config/types';
import { getSessionsTableColumnsData } from 'features/sessions/utils';

const initialSortingState: SortingState = [{ id: 'startAt', desc: true }];

export const useCoachTableData = (sessions: SessionListItemType[]) => {
  const columns = useMemo(() => coachSessionsTableColumnsData, []);

  const data = useMemo(
    () => getSessionsTableColumnsData(sessions),
    [sessions]
  ) as SessionTableItemType[];

  return useReactTable({
    columns,
    data,
    initialState: {
      sorting: initialSortingState,
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    sortDescFirst: false,
  });
};
